// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M3 15H15V3H3V15ZM3 15V21M15 4H21V16H15V4Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"flag-4"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M15 3H3V15H15V16H21V4H15V3Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 15H15V3H3V15ZM3 15V21M15 4H21V16H15V4Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Flag4Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'flag-4',
    ref,
    icon: element,
  },
));

Flag4Icon.displayName = 'Flag4Icon';

export default Flag4Icon;
